import type { NavigableResult } from '@/services/ask/selectors';

export type StepDirection = 'previous' | 'next';

/** Where the open result sits among the turn's results, and how to move off it. */
export type ResultStep = {
  index: number;
  count: number;
  onStep: (direction: StepDirection) => void;
};

/**
 * Builds the step state for the result `resultId` among `results`, or null
 * when it is not one of them. Stepping reports the destination to `onSelect`.
 */
export function buildResultStep(
  results: NavigableResult[],
  resultId: string,
  onSelect: (target: NavigableResult, direction: StepDirection) => void
): ResultStep | null {
  const index = results.findIndex((entry) => entry.result.resultId === resultId);

  if (index === -1) {
    return null;
  }

  return {
    index,
    count: results.length,
    onStep: (direction) => {
      const target = results[direction === 'previous' ? index - 1 : index + 1];

      if (target) {
        onSelect(target, direction);
      }
    },
  };
}
